//@flow
import * as React from 'react'
import { connect } from 'react-redux';
import { reduxForm,formValueSelector,submit,change } from 'redux-form';
import collect from 'collect.js'

import MaterialPaperWrap from '../../components/common/MaterialPaperWrap'
import ContainerRowActionDialog from '../../components/common/ContainerRowActionDialog'
import { ContainerRowError,ContainerRowSpace,PanelSpace,ContainerRowReduxCheckboxField } from '@lesofi/phoenix-react-js'
import ExpandPanelContainer from '../../components/phoenixComponents/ExpandPanelContainer'
import QualityReviewContainer from '../../components/QualityReview/QualityReviewContainer'
import SubmitButton from './SubmitButton'
import FormInfo from '@lesofi/phoenix-react-js/lib/kratos/FormInfo'
import PropertyInfo from '@lesofi/phoenix-react-js/lib/kratos/PropertyInfo'
import BillContactInfo from '@lesofi/phoenix-react-js/lib/kratos/BillContactInfo'
import ExemptReqInfo from '@lesofi/phoenix-react-js/lib/kratos/ExemptReqInfo'
import SignatureInfo from '@lesofi/phoenix-react-js/lib/kratos/SignatureInfo'
import EmergencyContactInfo from '@lesofi/phoenix-react-js/lib/kratos/EmergencyContactInfo'
import RegistrantInfo from '@lesofi/phoenix-react-js/lib/kratos/RegistrantInfo'
import UnitInfo from '@lesofi/phoenix-react-js/lib/kratos/UnitInfo'
import FormPageInfo from '@lesofi/phoenix-react-js/lib/kratos/FormPageInfo'
import ExceptionFormInfo from '@lesofi/phoenix-react-js/lib/kratos/ExceptionFormInfo'

import { validate,getQualityReviewFormNoOfError,isAnyFormErrors } from './validate'
import * as actions from '../../redux/kratos/actions';
import * as actionTypes from '../../redux/kratos/actionTypes'
import * as actConfDlgActions from '../../redux/actConfDialog/actions';
import { transformDataToEditFormData } from '../../redux/kratos/editFormData'

import type { DataFormContainer$Props } from './flowTypes'

const styles = ({
  root: {
      width: '100%',
  },
  heading: {
      fontSize: 15,
      fontWeight: 500
  },
  headingError: {
      fontSize: 15,
      fontWeight: 700,
      color: 'red'
  }
})

class DataFormContainer extends React.Component<DataFormContainer$Props> {
    refreshEditData(){
        if (this.props.query.isVerifyMode){
            const getTaskData = (this.props.getTaskData:any)
            getTaskData(this.props.query.jwt,this.props.query.taskAcceptedInfoId)
        }
    } 

    componentDidMount(){
        this.refreshEditData()
    }

    componentDidUpdate(prevProps:DataFormContainer$Props){
       const kratos = prevProps.kratos
       const formData = (kratos.formData:any)
       const nextKratos = this.props.kratos
       const nextFormData = (nextKratos.formData:any)
       const formType = formData["formType"]
       const nextFormType =  nextFormData["formType"]
       const formServiceYear = formData["formServiceYear"]
       const nextFormServiceYear =  nextFormData["formServiceYear"]
       
       if (formType && formData !== nextFormData && formServiceYear !== nextFormServiceYear) {
          transformDataToEditFormData(nextFormData,nextKratos)
       }
    }

    render(){
      const { formType,isApnNotFound,isStatementNotFound } = this.props
      const formError = this.props.kratos.formError
      const noOfErrorsInQualityReview = getQualityReviewFormNoOfError(this.props,collect(formError))
      let formPanels = this.props.generic.formExpandedPanels; 
      
      const formInfoFieldsError = isAnyFormErrors(formError,actionTypes.KRATOS_PANEL_FORM_INFO,this.props)
      let propertyInfoFieldsError = null
      let billContactInfoFieldsError = null
      let exemptReqInfoFieldsError = null
      let signatureInfoFieldsError = null
      let registrantFieldsError = null
      
      if (formType) {
        propertyInfoFieldsError=isAnyFormErrors(formError,actionTypes.KRATOS_PANEL_PROPERTY_INFO,this.props)
        billContactInfoFieldsError = isAnyFormErrors(formError,actionTypes.KRATOS_PANEL_BILLCONTACT_INFO,this.props)
        exemptReqInfoFieldsError = isAnyFormErrors(formError,actionTypes.KRATOS_PANEL_EXEMPTREQ_INFO,this.props)
        signatureInfoFieldsError = isAnyFormErrors(formError,actionTypes.KRATOS_PANEL_SIGNATURE_INFO,this.props)
        registrantFieldsError = isAnyFormErrors(formError,actionTypes.KRATOS_PANEL_REGISTRANT_INFO,this.props)
      }
      
      let unitInfo1FieldsError = null
      let unitInfo2FieldsError = null
      let unitInfo3FieldsError = null
      let unitInfo4FieldsError = null
      let unitInfo5FieldsError = null
      if (formType == 'rru') {
         unitInfo1FieldsError = isAnyFormErrors(formError,actionTypes.KRATOS_PANEL_UNIT_INFO_1,this.props)
         unitInfo2FieldsError = isAnyFormErrors(formError,actionTypes.KRATOS_PANEL_UNIT_INFO_2,this.props)
         unitInfo3FieldsError = isAnyFormErrors(formError,actionTypes.KRATOS_PANEL_UNIT_INFO_3,this.props)
         unitInfo4FieldsError = isAnyFormErrors(formError,actionTypes.KRATOS_PANEL_UNIT_INFO_4,this.props)
         unitInfo5FieldsError = isAnyFormErrors(formError,actionTypes.KRATOS_PANEL_UNIT_INFO_5,this.props)
      }

      let exceptionFormFieldsError = null 
      if (formType == 'exc') {
        exceptionFormFieldsError = isAnyFormErrors(formError,actionTypes.KRATOS_PANEL_EXCEPTION_FORM_INFO,this.props)
      }

      return (
          <div className='row'>
              <div className='col-sm'>
                    <form onSubmit={this.props.handleSubmit} > 
                      <div className='container'>
                        <ContainerRowReduxCheckboxField field={'isInvalidDoc'} label={'Invalid Document / Missing Pages / Not load'} />
                        
                        <ContainerRowActionDialog 
                            title={'Form Data Extraction'}
                            message={'Please do double check and confirm all your inputs before click submit.'}
                            submitFunc={this.props.submitReduxForm}
                        />

                        <SubmitButton {...this.props} />

                        {this.props.kratos.error?(
                          <ContainerRowError errorMsg={(this.props.kratos.error:any)} />
                        ):null}
                        <ContainerRowSpace />
                        
                        <ExpandPanelContainer
                              title={'PDF Content'} elementId={'pdfContent'}
                              actionType={actionTypes.KRATOS_PANEL_PDF_CONTENT} formPanels={formPanels}
                              disabled={false}
                              fieldError={null}
                          >
                            <div className="embed-responsive embed-responsive-1by1" style={{height: '100%'}}>
                                <iframe className="embed-responsive-item" src={this.props.query.docUrl}></iframe>
                            </div>
                        </ExpandPanelContainer>

                        <ExpandPanelContainer
                              title={'Form Information'} elementId={'formInfo'}
                              actionType={actionTypes.KRATOS_PANEL_FORM_INFO} formPanels={formPanels}
                              fieldError={formInfoFieldsError}
                          >
                            <FormInfo kratos={this.props.kratos} {...this.props} />
                        </ExpandPanelContainer>

                        <ExpandPanelContainer 
                            title={'EXCEPTION FORM INFORMATION'} elementId={'exceptionFormInfo'} formPanels={formPanels} 
                            actionType={actionTypes.KRATOS_PANEL_EXCEPTION_FORM_INFO}
                            visible={formType && (formType=='exc') ?true:false}
                            fieldError={exceptionFormFieldsError}
                        >
                           <ExceptionFormInfo kratos={this.props.kratos} />

                        </ExpandPanelContainer>    

                        <ExpandPanelContainer 
                            title={'PROPERTY INFORMATION'} elementId={'propertyInfo'} formPanels={formPanels} 
                            actionType={actionTypes.KRATOS_PANEL_PROPERTY_INFO}
                            visible={formType && (formType=='ec'||formType=='rr'||formType=='rrb' || formType=='rru' || formType=='exc') ?true:false}
                            fieldError={propertyInfoFieldsError}
                        >
                           <PropertyInfo kratos={this.props.kratos} {...this.props} />
                        </ExpandPanelContainer>

                        <ExpandPanelContainer 
                              title={'CHANGES TO BILLING CONTACT INFORMATION'} elementId={'billContactInfo'} formPanels={formPanels} 
                              actionType={actionTypes.KRATOS_PANEL_BILLCONTACT_INFO}
                              visible={formType && formType=='ec'?true:false}
                              fieldError={billContactInfoFieldsError}
                          >
                            <BillContactInfo {...this.props} />
                        </ExpandPanelContainer> 

                        <ExpandPanelContainer 
                              title={'TEMPORARY EXEMPTION REQUEST'} elementId={'tempExemptReq'} formPanels={formPanels} 
                              actionType={actionTypes.KRATOS_PANEL_EXEMPTREQ_INFO}
                              visible={formType && formType=='ec'?true:false}
                              fieldError={exemptReqInfoFieldsError}
                          >
                            <ExemptReqInfo {...this.props} />
                        </ExpandPanelContainer>

                        {formType && formType =='rru'?(
                        <ExpandPanelContainer 
                              title={'UNIT INFORMATION 1'} elementId={'panelUnitInfo1'} formPanels={formPanels} 
                              actionType={actionTypes.KRATOS_PANEL_UNIT_INFO_1}
                              visible={formType && formType=='rru'?true:false}
                              fieldError={unitInfo1FieldsError}
                          >
                            <UnitInfo elementId={'unitInfo1'} formIndex={1} {...this.props} />
                        </ExpandPanelContainer>
                        ):null} 

                        {formType && formType =='rru'?(
                        <ExpandPanelContainer 
                              title={'UNIT INFORMATION 2'} elementId={'panelUnitInfo2'} formPanels={formPanels} 
                              actionType={actionTypes.KRATOS_PANEL_UNIT_INFO_2}
                              visible={formType && formType=='rru'?true:false}
                              fieldError={unitInfo2FieldsError}
                          >
                            <UnitInfo elementId={'unitInfo2'} formIndex={2} {...this.props} />
                        </ExpandPanelContainer>
                        ):null}  
                        
                        {formType && formType =='rru'?(
                        <ExpandPanelContainer 
                              title={'UNIT INFORMATION 3'} elementId={'panelUnitInfo3'} formPanels={formPanels} 
                              actionType={actionTypes.KRATOS_PANEL_UNIT_INFO_3}
                              visible={formType && formType=='rru'?true:false}
                              fieldError={unitInfo3FieldsError}
                          >
                            <UnitInfo elementId={'unitInfo3'} formIndex={3} {...this.props} />
                        </ExpandPanelContainer>
                        ):null}

                        {formType && formType =='rru'?(
                        <ExpandPanelContainer 
                              title={'UNIT INFORMATION 4'} elementId={'panelUnitInfo4'} formPanels={formPanels} 
                              actionType={actionTypes.KRATOS_PANEL_UNIT_INFO_4}
                              visible={formType && formType=='rru'?true:false}
                              fieldError={unitInfo4FieldsError}
                          >
                            <UnitInfo elementId={'unitInfo4'}  formIndex={4} {...this.props} />
                        </ExpandPanelContainer>
                        ):null}

                        {formType && formType =='rru'?(
                        <ExpandPanelContainer 
                              title={'UNIT INFORMATION 5'} elementId={'panelUnitInfo5'} formPanels={formPanels} 
                              actionType={actionTypes.KRATOS_PANEL_UNIT_INFO_5}
                              visible={formType && formType=='rru'?true:false}
                              fieldError={unitInfo5FieldsError}
                          >
                            <UnitInfo elementId={'unitInfo5'} formIndex={5} {...this.props} />
                        </ExpandPanelContainer>
                        ):null}

                        <ExpandPanelContainer 
                              title={'SIGNATURE INFORMATION'} elementId={'signatureInfo'} formPanels={formPanels} 
                              actionType={actionTypes.KRATOS_PANEL_SIGNATURE_INFO}
                              visible={formType && (formType=='ec' || formType=='rru' )?true:false}
                              fieldError={signatureInfoFieldsError}
                          >
                            <SignatureInfo {...this.props} />
                        </ExpandPanelContainer>

                        <ExpandPanelContainer 
                              title={'EMERGENCY CONTACT INFORMATION'} elementId={'emergencyContactInfo'} formPanels={formPanels} 
                              actionType={actionTypes.KRATOS_PANEL_EMERGENCY_CONTACT_INFO}
                              visible={formType && (formType=='rr' || formType=='rrb')?true:false}
                          >
                            <EmergencyContactInfo {...this.props} />
                        </ExpandPanelContainer>

                        <ExpandPanelContainer 
                              title={'YOUR INFORMATION'} elementId={'yourInfo'} formPanels={formPanels} 
                              actionType={actionTypes.KRATOS_PANEL_REGISTRANT_INFO}
                              visible={formType && (formType=='rr' || formType=='rrb')?true:false}
                              fieldError={registrantFieldsError}
                          >
                            <RegistrantInfo {...this.props} />
                        </ExpandPanelContainer>

                        {formType && formType =='rru'?(  
                        <ExpandPanelContainer 
                              title={'FORM PAGE INFORMATION'} elementId={'formPageInfo'} formPanels={formPanels} 
                              actionType={actionTypes.KRATOS_PANEL_FORM_PAGE_INFO}
                              visible={formType && formType=='rru'?true:false}
                          >
                            <FormPageInfo {...this.props} />
                        </ExpandPanelContainer>
                        ):null}

                        <ExpandPanelContainer 
                              title={'Final Review Before Submission'} elementId={'Review_Questions'} formPanels={formPanels} 
                              actionType={actionTypes.KRATOS_PANEL_REVIEW_QUESTIONS}
                              visible={this.props.query.isVerifyMode?this.props.query.isVerifyMode:false}
                              fieldError={noOfErrorsInQualityReview}
                          >
                            <QualityReviewContainer 
                                elementId={'kratosPanelReviewQuestion'} 
                                changeFieldValue={this.props.changeFieldValue} 
                                questions={(this.props.kratos.reviewQuestions:any)} 
                            />
                        </ExpandPanelContainer> 

                      </div>   
                  </form>   
              </div>
          </div>
      )    
    }
}

const form='kratosDataFormContainer'
const selector = formValueSelector(form)

const submitMethod = (values, dispatch, props) => {
    const { kratos } = props;
    const { jwt,taskAcceptedInfoId } = props.query
    props.submitCloseActionDialog()
    props.formDataSubmission(jwt,taskAcceptedInfoId,values,kratos);
}

const DataFormContainerReduxForm = reduxForm({
    form: form,
    enableReinitialize: true,
    validate,
    onSubmit: submitMethod
})(DataFormContainer)

const mapStateToProps:any = (state, ownProps) => {
    return {
        kratos: state.kratos,
        generic: state.generic,
        initialValues: state.kratos.formData,
        selector: selector,
        actConfDialog: state.actConfDialog,
        isInvalidDoc: selector(state, 'isInvalidDoc'),
        formType: selector(state, 'formType'),
        formServiceYear: selector(state, 'formServiceYear'),
        isApnNotFound: selector(state, 'isApnNotFound'),
        isStatementNotFound: selector(state, 'isStatementNotFound'),
        isFirstNameNotReadable: selector(state, 'isFirstNameNotReadable'),
        isFirstNameFieldIsBlank: selector(state, 'isFirstNameFieldIsBlank'),
        isLastNameNotReadable: selector(state, 'isLastNameNotReadable'),
        isLastNameFieldIsBlank: selector(state, 'isLastNameFieldIsBlank'),
        isHouseNoNotReadable: selector(state, 'isHouseNoNotReadable'),
        isStreetNameNotReadable: selector(state, 'isStreetNameNotReadable'),
        isCityNotReadable: selector(state, 'isCityNotReadable'),
        isStateNotReadable: selector(state, 'isStateNotReadable'),
        isZipCodeNotReadable: selector(state, 'isZipCodeNotReadable'),
        isEmailNotReadable: selector(state, 'isEmailNotReadable'),
        isPhoneNotReadable: selector(state, 'isPhoneNotReadable'),
        isPhoneExtNotReadable: selector(state, 'isPhoneExtNotReadable'),
        isPoBoxNotReadable: selector(state, 'isPoBoxNotReadable'),
        isUnitAddr1NotReadable: selector(state, 'isUnitAddr1NotReadable'),
        isUnitAddr2NotReadable: selector(state, 'isUnitAddr2NotReadable'),
        isPrintNameNotReadable: selector(state, 'isPrintNameNotReadable'),
        isSignatureDateNotReadable: selector(state, 'isSignatureDateNotReadable'),
        isHouseId1NotReadable: selector(state, 'isHouseId1NotReadable'),
        isStreetName1NotReadable: selector(state, 'isStreetName1NotReadable'),
        isUnitId1NotReadable: selector(state, 'isUnitId1NotReadable'),
        isHouseId2NotReadable: selector(state, 'isHouseId2NotReadable'),
        isStreetName2NotReadable: selector(state, 'isStreetName2NotReadable'),
        isUnitId2NotReadable: selector(state, 'isUnitId2NotReadable'),
        isEmergencyFirstNameNotReadable: selector(state, 'isEmergencyFirstNameNotReadable'),
        isEmergencyLastNameNotReadable: selector(state, 'isEmergencyLastNameNotReadable'),
        isEmergencyHouseNumberNotReadable: selector(state, 'isEmergencyHouseNumberNotReadable'),
        isEmergencyStreetNameNotReadable: selector(state, 'isEmergencyStreetNameNotReadable'),
        isEmergencyCityNotReadable: selector(state, 'isEmergencyCityNotReadable'),
        isEmergencyStateNotReadable: selector(state, 'isEmergencyStateNotReadable'),
        isEmergencyZipCodeNotReadable: selector(state, 'isEmergencyZipCodeNotReadable'),
        isEmergencyPhoneNotReadable: selector(state, 'isEmergencyPhoneNotReadable'),
        isEmergencyEmailNotReadable: selector(state, 'isEmergencyEmailNotReadable'),
        isTotalUnitsPrintedNotReadable: selector(state, 'isTotalUnitsPrintedNotReadable'),
        isTotalUnitsEnteredNotReadable: selector(state, 'isTotalUnitsEnteredNotReadable'),
        isRegistrantFirstNameNotReadable: selector(state, 'isRegistrantFirstNameNotReadable'),
        isRegistrantLastNameNotReadable: selector(state, 'isRegistrantLastNameNotReadable'),
        isRegistrantPhoneNotReadable: selector(state, 'isRegistrantPhoneNotReadable'),
        isRegistrantEmailNotReadable: selector(state, 'isRegistrantEmailNotReadable'),
        isAptNotReadable: selector(state, 'isAptNotReadable'),
        isPropStreetNameNotReadable: selector(state, 'isPropStreetNameNotReadable'),
        isStreetName3NotReadable: selector(state, 'isStreetName3NotReadable'),
        isUnit1HouseNumberNotReadable: selector(state, 'isUnit1HouseNumberNotReadable'),
        isUnit2HouseNumberNotReadable: selector(state, 'isUnit2HouseNumberNotReadable'),
        isUnit3HouseNumberNotReadable: selector(state, 'isUnit3HouseNumberNotReadable'),
        isUnit4HouseNumberNotReadable: selector(state, 'isUnit4HouseNumberNotReadable'),
        isUnit5HouseNumberNotReadable: selector(state, 'isUnit5HouseNumberNotReadable'),
        isUnit1StreetNameNotReadable: selector(state, 'isUnit1StreetNameNotReadable'),
        isUnit2StreetNameNotReadable: selector(state, 'isUnit2StreetNameNotReadable'),
        isUnit3StreetNameNotReadable: selector(state, 'isUnit3StreetNameNotReadable'),
        isUnit4StreetNameNotReadable: selector(state, 'isUnit4StreetNameNotReadable'),
        isUnit5StreetNameNotReadable: selector(state, 'isUnit5StreetNameNotReadable'),
        isUnit1UnitNumberNotReadable: selector(state, 'isUnit1UnitNumberNotReadable'),
        isUnit2UnitNumberNotReadable: selector(state, 'isUnit2UnitNumberNotReadable'),
        isUnit3UnitNumberNotReadable: selector(state, 'isUnit3UnitNumberNotReadable'),
        isUnit4UnitNumberNotReadable: selector(state, 'isUnit4UnitNumberNotReadable'),
        isUnit5UnitNumberNotReadable: selector(state, 'isUnit5UnitNumberNotReadable'),
        isUnit1BedroomCountNotReadable: selector(state, 'isUnit1BedroomCountNotReadable'),
        isUnit2BedroomCountNotReadable: selector(state, 'isUnit2BedroomCountNotReadable'),
        isUnit3BedroomCountNotReadable: selector(state, 'isUnit3BedroomCountNotReadable'),
        isUnit4BedroomCountNotReadable: selector(state, 'isUnit4BedroomCountNotReadable'),
        isUnit5BedroomCountNotReadable: selector(state, 'isUnit5BedroomCountNotReadable'),
        isUnit1MoveinDateNotReadable: selector(state, 'isUnit1MoveinDateNotReadable'),
        isUnit2MoveinDateNotReadable: selector(state, 'isUnit2MoveinDateNotReadable'),
        isUnit3MoveinDateNotReadable: selector(state, 'isUnit3MoveinDateNotReadable'),
        isUnit4MoveinDateNotReadable: selector(state, 'isUnit4MoveinDateNotReadable'),
        isUnit5MoveinDateNotReadable: selector(state, 'isUnit5MoveinDateNotReadable'),
        isUnit1CurrentRentNotReadable: selector(state, 'isUnit1CurrentRentNotReadable'),
        isUnit2CurrentRentNotReadable: selector(state, 'isUnit2CurrentRentNotReadable'),
        isUnit3CurrentRentNotReadable: selector(state, 'isUnit3CurrentRentNotReadable'),
        isUnit4CurrentRentNotReadable: selector(state, 'isUnit4CurrentRentNotReadable'),
        isUnit5CurrentRentNotReadable: selector(state, 'isUnit5CurrentRentNotReadable'),
        isUnit1LastIncreaseDateNotReadable: selector(state, 'isUnit1LastIncreaseDateNotReadable'),
        isUnit2LastIncreaseDateNotReadable: selector(state, 'isUnit2LastIncreaseDateNotReadable'),
        isUnit3LastIncreaseDateNotReadable: selector(state, 'isUnit3LastIncreaseDateNotReadable'),
        isUnit4LastIncreaseDateNotReadable: selector(state, 'isUnit4LastIncreaseDateNotReadable'),
        isUnit5LastIncreaseDateNotReadable: selector(state, 'isUnit5LastIncreaseDateNotReadable'),
        isExemptionCode1NotReadable: selector(state, 'isExemptionCode1NotReadable'),
        isExemptionCode2NotReadable: selector(state, 'isExemptionCode2NotReadable'),
        isExemptionCode3NotReadable: selector(state, 'isExemptionCode3NotReadable')
    }
}

const mapDispatchToProps:any = (dispatch, ownProps) => {
    return {
      formDataSubmission: (jwt,taskAcceptedInfoId,kratosResultset,kratos) => {
        dispatch(actions.formDataSubmission(jwt,taskAcceptedInfoId,kratosResultset,kratos))  
      },
      submitOpenActionDialog: ()=> {
        dispatch(actConfDlgActions.openDialog())    
      },
      submitCloseActionDialog: ()=> {
        dispatch(actConfDlgActions.closeDialog())    
      },
      submitReduxForm: ()=>{
        dispatch(submit(form))
      },
      changeFieldValue: (field, value)=> {
        dispatch(change(form, field, value))
      },
      updateFormError: (error:any)=>{
        dispatch(actions.updateFormError(error))  
      },
      getTaskData: (jwt:string,taskAcceptedInfoId:number)=>{
        dispatch(actions.getTaskData(ownProps.kratos, jwt, taskAcceptedInfoId))  
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(DataFormContainerReduxForm)


// WEBPACK FOOTER //
// ./src/views/ProjectKratos/DataFormContainer.js